<template>
  <div>
    <SafetyEducation></SafetyEducation>
    <!--对话框-->
    <div>
      <Modal
        class="modal_div"
        v-model="modal1"
        width="80%"
        class-name="vertical-center-modal"
        @on-visible-change="onChange"
      >
        <div slot="header">
          <Row>
            <Col span="20">
              <span class="header_div">{{ this.ref }}</span>
            </Col>
            <Col span="3"> </Col>
          </Row>
        </div>
        <div style="text-align: center">
          <p class="font_size">{{ profile }}</p>
          <div v-for="(item, index) in VRImg" :key="index">
            <img style="width: 80%" :src="item" alt="暂无图片" />
          </div>
        </div>
        <div slot="footer">
          <Button @click="modal1 = false">取消</Button>
        </div>
      </Modal>
    </div>
  </div>
</template>

<script>
import ThreeDimensional from "./ThreeDimensional.vue";
import SafetyEducation from "./SafetyEducation.vue";
import AR from "./AR.vue";
export default {
  components: {
    ThreeDimensional,
    SafetyEducation,
    AR,
  },
  data() {
    return {
      modal1: false,
      profile: "",
      item01: [],
      ref: "",
      VRImg: [],
      photoArr1: [
        {
          photoUrl: "../../../static/img/photo/photo_quality.jpg",
          photoUrl1: "../../../static/img/photo-da/photo_quality.jpg",
          p:
            "尺寸：2.3*2.8m\n" +
            "材质及做法：钢筋设置、钢筋绑扎、框架柱砼、柱支模等工艺",
          VRImg: ["../../../static/img/photo-da/photo_quality.jpg"],
          ref: "建筑施工工程梁柱节点质量样板",
          money: "¥13000.00",
          classify: [
            {
              type: "黄色",
              money: "¥13000.00",
              img: "../../../static/img/photo-da/photo_quality.jpg",
            },
          ],
          title: "工法质量样板展示区",
          belong: "建筑施工工程梁柱节点质量样板",
          path: "/home/Buy/Quality",
        },
        {
          photoUrl: "../../../static/img/photo/photo_detached.jpg",
          photoUrl1: "../../../static/img/photo-da/photo_detached.jpg",
          p:
            "尺寸：2.3*2.8m\n" +
            "材质及做法：钢筋设置、钢筋绑扎、框架柱砼、柱支模等工艺。",
          VRImg: ["../../../static/img/photo-da/photo_detached.jpg"],
          ref: "独立柱质量样板",
          money: "¥13000.00",
          classify: [
            {
              type: "黄色",
              money: "￥13000.00",
              img: "../../../static/img/photo-da/photo_detached.jpg",
            },
          ],
          title: "工法质量样板展示区",
          belong: "独立柱质量样板",
          path: "/home/Buy/Quality",
        },
        {
          photoUrl: "../../../static/img/photo/photo_shear.jpg",
          photoUrl1: "../../../static/img/photo-da/photo_detached.jpg",
          p: "尺寸：2.3*2.8m\n" + "材质及做法：后浇带，钢筋，支模，砼浇筑",
          VRImg: ["../../../static/img/photo-da/photo_detached.jpg"],
          ref: "剪力墙质量样板",
          money: "¥13000.00",
          classify: [
            {
              type: "黄色",
              money: "￥13000.00",
              img: "../../../static/img/photo-da/photo_detached.jpg",
            },
          ],
          title: "工法质量样板展示区",
          belong: "剪力墙质量样板",
          path: "/home/Buy/Quality",
        },
        {
          photoUrl: "../../../static/img/photo/photo_electrical.jpg",
          photoUrl1: "../../../static/img/photo-da/photo_electrical.jpg",
          p:
            "尺寸：2.3*2.8m\n" +
            "材质及做法：机械开槽，甩浆挂网，混凝土填塞，开关插座预埋，开关箱，等电位，多媒体集线箱预埋等工艺",
          VRImg: ["../../../static/img/photo-da/photo_electrical.jpg"],
          ref: "电气预埋质量样板",
          money: "¥13000.00",
          classify: [
            {
              type: "浅灰色",
              money: "¥13000.00",
              img: "../../../static/img/photo-da/photo_electrical.jpg",
            },
          ],
          title: "工法质量样板展示区",
          belong: "电气预埋质量样板",
          path: "/home/Buy/Quality",
        },
        {
          photoUrl: "../../../static/img/photo/photo_drain.png",
          photoUrl1: "../../../static/img/photo-da/photo_drain.png",
          p:
            "尺寸：2.3*2.8m\n" +
            "材质及做法：给水管安装，给水口留设，排水立管、排水支管安装，排水口留设，积水器安装，卫生间防水做法等工艺",
          VRImg: ["../../../static/img/photo-da/photo_drain.png"],
          ref: "同层排水质量样板",
          money: "¥13000.00",
          classify: [
            {
              type: "白色",
              money: "¥13000.00",
              img: "../../../static/img/photo-da/photo_drain.png",
            },
          ],
          title: "工法质量样板展示区",
          belong: "同层排水质量样板",
          path: "/home/Buy/Quality",
        },
        {
          photoUrl: "../../../static/img/photo/photo_roof.png",
          photoUrl1: "../../../static/img/photo-da/photo_roof.png",
          p:
            "尺寸：2.3*2.8m\n" +
            "材质及做法：天沟，斜坡，屋面地面分层，防水保温",
          VRImg: ["../../../static/img/photo-da/photo_roof.png"],
          ref: "屋面样板",
          money: "¥13000.00",
          classify: [
            {
              type: "灰色",
              money: "￥13000.00",
              img: "../../../static/img/photo-da/photo_roof.png",
            },
          ],
          title: "工法质量样板展示区",
          belong: "屋面样板",
          path: "/home/Buy/Quality",
        },
        {
          photoUrl: "../../../static/img/photo/photo_roof01.jpg",
          photoUrl1: "../../../static/img/photo-da/photo_roof01.jpg",
          p:
            "尺寸：2.3*2.8m\n" +
            "材质及做法：砌体，烟道，气管防雷接地，防水保温",
          VRImg: ["../../../static/img/photo-da/photo_roof01.jpg"],
          ref: "屋面样板",
          money: "¥13000.00",
          classify: [
            {
              type: "白色",
              money: "￥13000.00",
              img: "../../../static/img/photo-da/photo_roof01.jpg",
            },
          ],
          title: "工法质量样板展示区",
          belong: "屋面样板",
          path: "/home/Buy/Quality",
        },
        {
          photoUrl: "../../../static/img/photo/photo_stairs.jpg",
          photoUrl1: "../../../static/img/photo-da/photo_stairs.jpg",
          p: "尺寸：2.3*2.8m\n" + "材质及做法：钢筋，支模，混凝土浇筑",
          VRImg: ["../../../static/img/photo-da/photo_stairs.jpg"],
          ref: "楼梯样板",
          money: "¥13000.00",
          classify: [
            {
              type: "黄色",
              money: "¥13000.00",
              img: "../../../static/img/photo-da/photo_stairs.jpg",
            },
          ],
          title: "工法质量样板展示区",
          belong: "楼梯样板",
          path: "/home/Buy/Quality",
        },
        {
          photoUrl: "../../../static/img/photo/photo_brickwork.jpg",
          photoUrl1: "../../../static/img/photo-da/photo_brickwork.jpg",
          p:
            "尺寸：2.3*2.8m\n" +
            "材质及做法：门窗洞口，砌体粉饰，保温，电气预埋",
          VRImg: ["../../../static/img/photo-da/photo_brickwork.jpg"],
          ref: "砌体抹灰样板",
          money: "¥13000.00",
          classify: [
            {
              type: "白色",
              money: "¥13000.00",
              img: "../../../static/img/photo-da/photo_brickwork.jpg",
            },
          ],
          title: "工法质量样板展示区",
          belong: "砌体抹灰样板",
          path: "/home/Buy/Quality",
        },
      ],
    };
  },

  methods: {
    onChange() {
      document
        .querySelector("body")
        .setAttribute("style", "overflow:hidden;padding-right:15px");
    },
    /*弹出对话框*/
    getMoney(item) {
      this.VRImg = item.VRImg;
      this.modal1 = true;
      this.item01 = item;
      this.ref = item.ref;
      this.profile = item.p;
    },
    /*刚进页面的立即购买*/
    getMoney01(item) {
      this.goBuy(item);
    },
    /*弹出框里面立即购买*/
    goBuyGo() {
      this.modal1 = false;
      this.goBuy(this.item01);
      document.querySelector("body").setAttribute("style", "overflow:auto");
    },
    /*购买*/
    goBuy(item) {
      sessionStorage.setItem("title", item.title);
      sessionStorage.setItem("belong", item.belong);
      sessionStorage.setItem("path", item.path);
      sessionStorage.setItem("money", item.money);
      sessionStorage.setItem("ref", item.ref);
      sessionStorage.setItem("photoUrl1", item.photoUrl1);
      sessionStorage.setItem("classify", JSON.stringify(item.classify));
      this.$router.push({
        path: "/home/buyGo",
      });
    },
  },
};
</script>
<style>
.modal_div .ivu-modal-header p,
.modal_div .ivu-modal-header-inner {
  color: #02a0e7;
  font-size: 20px;
  font-weight: bold;
  font-family: 新宋体, serif;
}

/*面包屑*/
.col_bread .ivu-breadcrumb {
  font-size: 16px;
}
</style>
<style scoped>
/*弹出框字体*/
.header_div {
  color: #02a0e7;
  font-size: 20px;
  font-weight: bold;
  font-family: 新宋体, serif;
}

.font_size {
  font-size: 19px;
  white-space: pre-wrap;
}

.buy_col01 {
  width: 270px;
  background: #f7f7f7;
  text-align: center;
  cursor: pointer;
  margin: 14px 0px 0 22px;
  box-shadow: 0 0 2px 2px rgba(0, 0, 0, 0.2);
  border-radius: 6px;
}

.buy_col01:hover {
  box-shadow: 0 0 3px 3px rgba(0, 0, 0, 0.2);
}

.buy_col01 .sp:hover {
  color: red;
}

.buy_rule {
  width: 270px;
  height: 240px;
  display: flex;
  justify-content: center;
  align-items: center;
}

.buy_rule img {
  width: 210px;
  height: 210px;
}

.sp {
  font-size: 14px;
  height: 40px;
}
</style>



// WEBPACK FOOTER //
// src/components/Buy/Quality.vue